// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".satisfi_fade-enter-active,\n.satisfi_fade-leave-active {\n    transition: opacity .5s;\n}\n\n.satisfi_fade-enter,\n.satisfi_fade-leave-to\n\n/* .fade-leave-active below version 2.1.8 */\n    {\n    opacity: 0;\n}", ""]);
// Exports
module.exports = exports;
